module.exports = __webpack_public_path__ + "img/pic_210006_3.57e5ded6.jpg";